import type { LoginWithAuthMicroservice } from "./types";

const URL = import.meta.env.API_BASE_URL as string;
const KEY = import.meta.env.PLATFORM_AUTH_KEY as string;

export const loginWithAuthMS: LoginWithAuthMicroservice = async (
  user,
  token,
  signal,
) => {
  if (!token) {
    throw new Error(
      `Invalid (${typeof token}) token passed to loginWithAuthMS`,
    );
  }

  const { given_name, family_name, email, sub } = user;

  const response = await fetch(`${URL}/auth/login`, {
    method: "POST",
    headers: {
      "Ocp-Apim-Subscription-Key": KEY,
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({
      FirstName: given_name,
      LastName: family_name,
      Email: email,
      ServiceProviderUserId: sub,
      AccessibleApplications: ["Storage"],
    }),
    signal,
  });

  if (response.ok) {
    return response;
  }

  throw new RangeError("loginWithAuthMS response is not ok");
};
